const DollarIcon = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
  >
    <path
      d="M8 1.33301V14.6663M10.6667 3.33301H6.66667C5.5621 3.33301 4.66667 4.22844 4.66667 5.33301C4.66667 6.43758 5.5621 7.33301 6.66667 7.33301H9.33333C10.4379 7.33301 11.3333 8.22844 11.3333 9.33301C11.3333 10.4376 10.4379 11.333 9.33333 11.333H5.33333"
      stroke="white"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DollarIcon;
